// Meta Lead event for the ad campaigns that send people to the public scorecard form.
// The pixel itself is loaded from index.html; window.fbq is absent on staff pages.
export function trackScorecardLead(): void {
  window.fbq?.('track', 'Lead', { content_name: 'Reputation Scorecard' });
}
